import 'flag-icons/css/flag-icons.min.css';
import {Box} from '@mui/material';
import type {SupplierCountry} from "~/pages/supplier-360/types/Supplier360Types";

const FLAG_SIZE = 20;

type SupplierCountryFlagProps = {
    country: SupplierCountry | null;
};

export function SupplierCountryFlag({country}: SupplierCountryFlagProps) {
    const flag = country?.flag || country?.code_a2?.toLowerCase();
    if (!flag) return '—';

    return (
        <Box
            component="span"
            className={`fi fis fi-${flag}`}
            role="img"
            aria-label={country?.name ?? flag}
            title={country?.name ?? flag}
            sx={{
                '&.fi': {width: FLAG_SIZE},
                height: FLAG_SIZE,
                lineHeight: `${FLAG_SIZE}px`,
                borderRadius: '50%',
                display: 'inline-block',
                flexShrink: 0,
                overflow: 'hidden',
                backgroundSize: 'cover',
            }}
        />
    );
}
